var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-justify-between tw-mb-5"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }